import {Component, Vue, Watch} from 'vue-property-decorator'
import {UserModule} from '@/store/modules/user'
import {
    gettHeaderByType, settHeaderByType
} from '@/api/common'

import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from '@/utils/index'

import {
    getFinanceContractTemplateById,
    delFinanceContractTemplateById,
    getFinanceContractTemplateList,
    generatePdf,getCompanyList
} from "@/api/financial-center";
import commonData from "@/utils/commonData";
import htmlDocx from 'html-docx-js/dist/html-docx';

@Component({})
export default class SchoolList extends Vue {
    socket: any = null
    tableHeadPopoverShow = false
    tableData: any = []
    tableHeader: any = []
    checkTableRow: any = []
    tableHeadFilter = {
        souCourseTypeIdList: [],
        souCoursePrice: '',
        dissertationType: '',
        companyName: '',
        name: '',
    }
    page = 1
    limit = 20
    total = 0


    addDialog = false
    sendBackSelect = ''
    schoolName = ''
    schoolTypesList = [
        {value: '0', name: '海外大学'},
        {value: '1', name: '国内大学'},
        {value: '2', name: '中学'}
    ]
    schoolType = ''
    loading = false
    sendBackClueID: number; // 退户线索id
    menuBtn = menuBtn
    deleteDialog = false
    // cancelTabkBackClueId: number
    // sendBackDialogConfirmButtonDisabled = false
    // rowData = null
    // delType: any = null
    // repeatName: any = null
    // uploadUrl: any = null
    // uploadDialog = false
    // uploadData = null
    exportButtonDisabled = false
    timer = null

    typeList = commonData.projectTypeArray
    draggableList = []
    draggableListChange = []
    vdaH = 0
    popHeight = 0
    tableKey = Math.random()
    deleteId = ''
    downloadDialog =  false
    downloadType = 'pdf'
    downloadId = ''
    downloadLoading =  false
    // computed
    companyList = []

    get userId() {
        return UserModule.userId
    }

    // created
    created() {
        this.getTableHeader()
        // if (this.userId) this.initSocket()
        // const h = document.documentElement.clientHeight || document.body.clientHeight;
        // this.vdaH = h - 260;
        // this.popHeight = this.vdaH
        // if(process.env.NODE_ENV === 'development') {
        //     this.uploadUrl = process.env.VUE_APP_BASE_CRM_API_PROXY + '/tools/importSchool'
        // } else {
        //     if(window.location.origin.includes('-testserver')) {
        //         this.uploadUrl = process.env.VUE_APP_DEV_API + '/tools/importSchool'
        //     } else {
        //         this.uploadUrl = process.env.VUE_APP_MASTER_API + '/tools/importSchool'
        //     }
        // }
        this.getCompanyList()

    }
    // 所属公司列表
    async getCompanyList() {
        const data: any = await getCompanyList()
        this.companyList = data.companyList
    }

    // 转化项目类型
    changeSouCourseType(id) {
        let label = ''
        this.typeList.forEach((item: any) => {
            if (item.value == id) {
                label = item.label
            }
        })
        return label
    }


    getRowKeys(row: any) {
        return row.id
    }

    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({headerIds: this.draggableList, types: 18})
            this.$message.success('设置成功')
            this.tableHeadPopoverShow = false
            this.getTableHeader()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    doCancel() {
        this.draggableListChange = JSON.parse(JSON.stringify(this.draggableList))
        this.tableHeadPopoverShow = false
    }

    changeTable(val) {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }

    async getTableData() {
        this.loading = true

        const obj = {...this.tableHeadFilter, page: this.page, limit: this.limit}
        await getFinanceContractTemplateList(delNullProperty(obj)).then((data: any)=>{
        this.tableData = data.financeContractTemplateList
        this.total = data.allNum
        this.tableKey = Math.random()
        this.$nextTick(() => {
            if (this.$refs.multipleTable) {
                (this.$refs.multipleTable as HTMLFormElement).doLayout();
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            }
        });
        this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }


    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }

    handleScan(row: any) {
        if (!this.menuBtn(329)) return
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/contractTemplateInfo?contractTemplateId=' + row.id)
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }


    editSchool(row: any) {
        let url = window.location.origin + this.$route.matched[0].path
        url += '/newContractTemplate?contractTemplateId=' + row.id
        this.openPage(url)
    }

    deleteSchool(id) {

        this.deleteId = id
        this.deleteDialog = true
    }

    doDeleteCancel() {
        this.deleteDialog = false
    }

    async doDelete() {
        await delFinanceContractTemplateById({id: this.deleteId})
        this.$message.success('删除成功')
        this.deleteDialog = false
        this.getTableData()
    }

    // 新建合同模板
    addContractTemplate() {
        let url = ''
        url = this.$route.matched[0].path + '/newContractTemplate'
        this.openPage(url)
    }

    openPage(url: string) {
        const win = window.open(url, '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                clearInterval(timer)
                this.getTableData()
            }
        }, 500)
    }


    async getTableHeader() {
        this.loading = true
        const data: any = await gettHeaderByType(18)
        this.draggableList = data.headerUserList
        this.tableHeader = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.loading = false
        this.getTableData()
    }

    /*
    按钮权限验证
    */
    handleBtn(id: number) {
        return menuBtn(id)
    }

    /*
    *下载合同模板*/
    async download(pdfHtml) {
            //   生成pdf
            generatePdf({
                htmlStr: pdfHtml,
                marginTop: 50,
                marginBottom: 50,
            }).then((data1: any) => {
                const aUrl = data1.url
                this.downloadLoading = false
                // 创建a链接下载
                window.open(aUrl, '_blank')
            }).catch(err=>{
                this.downloadLoading = false
            })

    }

    handleCopy(id) { // 复制功能
        //     携带内容跳转新建
        const url = this.$route.matched[0].path + '/newContractTemplate?contractTemplateOldId=' + id
        this.openPage(url)
    }


    openDownload(id) {
        this.downloadDialog = true
        this.downloadId = id
    }

    exportAsWord(pdfHtml, name) {
        // const content = this.$refs.contentToExport.innerHTML;
        const converted = htmlDocx.asBlob(pdfHtml);
        const url = URL.createObjectURL(converted);
        const link = document.createElement('a');
        link.href = url;
        link.download = name + '.docx';
        link.click();
        this.downloadLoading = false
    }

    doDownloadCancel(){
        this.downloadDialog = false
    }

    async doDownload() {
        this.downloadLoading = true
        //   获取详情
        const data: any = await getFinanceContractTemplateById({id: this.downloadId}).then((data: any) => {
            let pdfHtml = data.financeContractTemplate.detail
            const name = data.financeContractTemplate.name
            pdfHtml = pdfHtml.replace('{{优惠金额}}', '') // 下载去掉{{优惠金额}}
            // 将表格字体大小统一
            pdfHtml = pdfHtml.replace('<b><sub>甲方</sub></b>', '<b>甲方</b>')
            // 去掉生成word时的虚线


            if (this.downloadType == 'pdf') {
                this.download(pdfHtml)
            } else if (this.downloadType == 'word') {
                this.exportAsWord(pdfHtml, name)
            }
            this.downloadDialog = false
        }).catch(err => {
            this.downloadLoading = false
        })
    }

    // @Watch('userId')
    // handleWatchUserId() {
    //     this.initSocket()
    // }
}
